function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80.4494 1L65.2305 22.8036H69.903L85.201 1H80.4494Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M70.39 1L74.8679 7.42478L72.5316 10.9292L65.6201 1H70.39Z",
  fill: "url(#paint0_linear_7131_133927)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M80.9031 22.8053L75.9385 15.6991L78.2748 12.292L85.5756 22.8053H80.9031Z",
  fill: "url(#paint1_linear_7131_133927)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.7792 1H63.8677V22.8036H59.7792V21.9892C58.5984 22.6336 57.2427 23 55.8011 23C51.2241 23 47.5137 19.3064 47.5137 14.75C47.5137 10.1936 51.2241 6.5 55.8011 6.5C57.2427 6.5 58.5984 6.86643 59.7792 7.51081V1ZM55.7574 19.3791C58.3497 19.3791 60.4512 17.2871 60.4512 14.7065C60.4512 12.126 58.3497 10.034 55.7574 10.034C53.1651 10.034 51.0637 12.126 51.0637 14.7065C51.0637 17.2871 53.1651 19.3791 55.7574 19.3791Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M47.919 1L32.7158 22.8036H37.482L52.6706 1H47.919Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4861 1L42.256 7.61947L39.6277 11.3186L32.5215 1H37.4861Z",
  fill: "url(#paint2_linear_7131_133927)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.2655 1H31.354V22.8036H27.2655V21.9892C26.0847 22.6336 24.729 23 23.2874 23C18.7104 23 15 19.3064 15 14.75C15 10.1936 18.7104 6.5 23.2874 6.5C24.729 6.5 26.0847 6.86643 27.2655 7.51081V1ZM23.2438 19.3791C25.8361 19.3791 27.9376 17.2871 27.9376 14.7065C27.9376 12.126 25.8361 10.034 23.2438 10.034C20.6515 10.034 18.55 12.126 18.55 14.7065C18.55 17.2871 20.6515 19.3791 23.2438 19.3791Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7131_133927",
  x1: 69.3192,
  y1: 2.36283,
  x2: 75.7294,
  y2: 10.1014,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.55
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_7131_133927",
  x1: 81.9739,
  y1: 21.1504,
  x2: 74.0981,
  y2: 10.533,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6966FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6966FF",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_7131_133927",
  x1: 36.4153,
  y1: 2.41628,
  x2: 43.0605,
  y2: 10.5421,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.55
})));

function SvgDydx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 24,
    viewBox: "0 0 101 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydx);
export default __webpack_public_path__ + "static/media/Dydx.8c067594b2d304e9dee057c16e4a09dc.svg";
export { ForwardRef as ReactComponent };